import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import Pagination from 'components/Libs/Pagination';
import TextField from 'material-ui/TextField';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

const styles = {
    textField: {
        hintStyle:{
            fontSize: 12,
        },
        style: {
            fontSize: 12,
        },
    },
    table: {
        row: {
            style: {
                height: '28px',
            }
        },
        col: {
            style: {
                padding: '0 24px',
                height: '28px',
            }
        },
        sortLayoutByn: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
        },
        smallCol: {
            style: {
                position: 'relative',
                cursor: 'pointer',
                padding: '0 24px',
                width: '55px'
            }
        },
        firstCol: {
            style: {
                padding: '0 24px',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
            }
        },
        fullColumn: {
            style: {
                padding: '0 24px',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                width: "300px",

            }
        }
    }
};

class AnnotationList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            directionById: true,
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            annotations: props.annotations,
            searchText: '',
        };

        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.filterAnnotations = this.filterAnnotations.bind(this);
        this.sortById = this.sortById.bind(this);
        this.changeSortById = this.changeSortById.bind(this);
    }

    sortById(items) {
        const newItems = [ ...items ];

        newItems.sort((a, b) => {
            if (this.state.directionById) {
                if (a.id > b.id) {
                    return 1;
                }

                if (a.id < b.id) {
                    return -1;
                }

                return 1;
            } else {
                if (a.id < b.id) {
                    return 1;
                }

                if (a.id > b.id) {
                    return -1;
                }

                return 1;
            }
        });

        return newItems;
    }

    changeSortById() {
        this.setState({
            directionById: !this.state.directionById,
        }, () => {
            const { annotations } = this.filterAnnotations(this.state.searchText, this.props.annotations);

            this.setState({
                page: 1,
                annotations: this.sortById(annotations),
                total: annotations.length,
            }, () => {
                this.handleUpdateRow(this.state);
            });
        })
    }

    filterAnnotations(text = this.state.searchText, annotations = this.props.annotations) {
        text = text.toLowerCase();

        const filteredAnnotations = annotations.filter((annotation) => {
            if (_.has(annotation, 'features.rule')
                && annotation.features.rule.toLowerCase().includes(text)) {
                return true;
            }

            if (_.has(annotation, 'features.majorType')
                && annotation.features.majorType.toLowerCase().includes(text)) {
                return true;
            }

            if (_.has(annotation, 'features.string')
                && annotation.features.string.toLowerCase().includes(text)) {
                return true;
            }

            if (_.has(annotation, 'type')
                && annotation.type.toLowerCase().includes(text)) {
                return true;
            }

            if (annotation.id) {
                const id = annotation.id + '';
                if (id.includes(text)) {
                    return true;
                }
            }

            return false;
        });

        return {
            searchText: text,
            annotations: filteredAnnotations,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { annotations } = this.filterAnnotations(this.state.searchText, nextProps.annotations);

        this.sortById(annotations);

        this.setState({
            page: 1,
            annotations: this.sortById(annotations),
            total: nextProps.annotations.length,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    handleSearch(e, value) {
        const { annotations, searchText } = this.filterAnnotations(value);

        this.setState({
            page: 1,
            annotations,
            searchText,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.annotations.slice(from, to);
    }

    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;

        this.setState(state);
    }

    render() {
        const { annotationsHeaders } = this.props;
        const { annotations, rowsPerPage, page, numberOfRows, rows, searchText } = this.state;

        return (
            <div className='annotations-list-b'>
                <div className='navigation'>

                    <div className='navigation-search'>
                        <TextField
                            hintText='Search'
                            hintStyle={styles.textField.hintStyle}
                            style={styles.textField.style}
                            onChange={this.handleSearch}
                            value={searchText || ''}
                        />
                    </div>

                    <div className='navigation-arrows'>
                        <Pagination
                            total={annotations.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            numberOfRows={numberOfRows}
                            updateRows={this.handleUpdateRow}
                        />
                    </div>

                    <div className='navigation-info'>
                        Annotations: {annotations.length},
                        Time: {annotationsHeaders['x-parse-time']} ms,
                        Server: {annotationsHeaders['x-server-name']}
                    </div>
                </div>

                <div className='annotations-table'>
                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow style={styles.table.row.style}>
                                <TableHeaderColumn style={styles.table.col.style}>Value</TableHeaderColumn>
                                <TableHeaderColumn style={styles.table.col.style}>Rule</TableHeaderColumn>
                                <TableHeaderColumn style={styles.table.col.style}>Type</TableHeaderColumn>
                                <TableHeaderColumn style={styles.table.col.style}>MajorType</TableHeaderColumn>
                                <TableHeaderColumn style={styles.table.fullColumn.style}>Features</TableHeaderColumn>
                                <TableHeaderColumn style={styles.table.smallCol.style}>
                                    <div style={styles.table.sortLayoutByn} onClick={this.changeSortById}></div>id
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {
                                rows.map((annotation, i) => {
                                    return (<TableRow style={styles.table.row.style} key={i}>
                                        <TableRowColumn style={styles.table.firstCol.style}>{annotation.features.string}</TableRowColumn>
                                        <TableRowColumn style={styles.table.col.style}>{annotation.features.rule}</TableRowColumn>
                                        <TableRowColumn style={styles.table.col.style}>{annotation.type}</TableRowColumn>
                                        <TableRowColumn style={styles.table.col.style}>{annotation.features.majorType}</TableRowColumn>
                                        <TableRowColumn style={styles.table.fullColumn.style}>
                                            {annotation.features ? JSON.stringify(annotation.features, null, 2) : ''}
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.table.smallCol.style}>{annotation.id}</TableRowColumn>
                                    </TableRow>);
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ annotations: { items: annotations, headers: annotationsHeaders } }) => {
        return {
            annotations,
            annotationsHeaders,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(AnnotationList);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/List/Annotation.jsx